export class ICDCodeMedicationRequestForm {
    concept = null;
    medicationRequestForm = null;
    note = null;
}